import { useMemo } from 'react'
import { checkAuthorization } from 'utils/checkAuthorization'
import type { TUseIrrigationEditPermissionsParams } from '../types'

/**
 * Determines if the user can edit the ICS Dashboard irrigation schedules
 * Returns false if:
 * - User doesn't have EDIT_ICS_DASHBOARD permission
 * - Any zone has a 3rd-party control provider
 */
export const useIrrigationEditPermissions = ({
  selectedPropertyId,
  irrigationZoneEmitters,
}: TUseIrrigationEditPermissionsParams) => {
  const canEditIcsDashboard =
    selectedPropertyId &&
    checkAuthorization({
      entity: selectedPropertyId,
      permission: 'EDIT_ICS_DASHBOARD',
    })

  const hasControlProvider = useMemo(
    () => Object.values(irrigationZoneEmitters ?? {}).some((emitter) => emitter.hasControlProvider === true),
    [irrigationZoneEmitters],
  )

  const canEdit = canEditIcsDashboard && !hasControlProvider

  return {
    canEdit,
    canEditIcsDashboard,
    hasControlProvider,
  }
}
